import React from 'react';
import { Modal, Text, i18n, tokens, TranslatedBoldedSentence } from '@simplybenefits/sb-ui-library';

/**
 * @param {Function} props.onBack - Callback to return to the previous claim page
 * @param {Function} props.onClose - Callback to cancel the claim flow
 * @param {string} props.title - Modal title
 */
const ClaimTermsModal = ({ onBack, onClose, title }) => (
    <Modal
        open={true}
        onClose={ onClose }
        onBack={ onBack }
        title={ title }
    >
        <Text bold mediumLarge display="flex" customStyle={{ marginBottom: 10 }}>
            { i18n.t(tokens.labels.claims.claimTermsAndConditionsTitle) }
        </Text>

        <TranslatedBoldedSentence token={tokens.labels.claims.claimTermsAndConditionsBody} />

        <Text light small display="flex" customStyle={{ marginBottom: 20, whiteSpace: 'pre-line' }}>
            
        </Text>

        <Text bold mediumLarge display="flex" customStyle={{ marginBottom: 10 }}>
            { i18n.t(tokens.labels.claims.claimCertificationAndAuthTitle) }
        </Text>

        <Text light small display="flex" customStyle={{ whiteSpace: 'pre-line' }}>
            { i18n.t(tokens.labels.claims.claimCertificationAndAuthBody) }
        </Text>
    </Modal>
);

export default ClaimTermsModal;